import React from 'react';
import Plot from 'react-plotly.js';

interface HorizontalBarChartProps {
  data: any;
  layout: any;
}

const HorizontalBarChart = (props: HorizontalBarChartProps) => {
  return (
    <Plot
      data={props?.data}
      layout={props?.layout}
      style={{ width: '100%', height: '100%' }}
    />
  );
};

export default HorizontalBarChart;
